module.exports = __webpack_public_path__ + "static/img/class_19.95a55074.jpg";